import apiClient from './client'

export const tagApi = {
  list: async (): Promise<string[]> => {
    const response = await apiClient.get('/tags')
    return response.data.tags
  },
}
